import { render, staticRenderFns } from "./WidgetDocuments.vue?vue&type=template&id=e2b57884&scoped=true&"
import script from "./WidgetDocuments.vue?vue&type=script&lang=js&"
export * from "./WidgetDocuments.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDocuments.vue?vue&type=style&index=0&id=e2b57884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b57884",
  null
  
)

export default component.exports